<template>
    <TheAllCommentsTable />
</template>
<script>
export default {
  name: 'AllComments'
}
</script>
